export interface FormMessage {
  iespReevalNote: string;
}

export const formMessages: FormMessage = {
  iespReevalNote:
    'Parent of a student with an IESP/SP does not respond or consent to reevaluation',
};
